import { Reveal } from "./Reveal";
import { AMENITIES, AMENITY_TAGS } from "../../lib/content";

export default function Amenities() {
  return (
    <section
      id="amenities"
      data-testid="amenities"
      className="relative bg-[#050505] py-28 md:py-40 scroll-mt-20"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div className="max-w-2xl">
            <Reveal>
              <span className="text-xs tracking-luxe uppercase text-[#d4af37]">
                Everyday Rituals
              </span>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="font-serif-lux text-4xl md:text-6xl mt-6 leading-[1.05] text-[#f5f5f0]">
                Amenities for a{" "}
                <span className="italic gold-gradient-text">slower, richer</span>{" "}
                life.
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.2}>
            <p className="text-[#9a968c] max-w-xs leading-relaxed">
              Over forty curated experiences, from cold-morning swims to
              firelit evenings — designed to be used, not just admired.
            </p>
          </Reveal>
        </div>

        {/* Bento grid */}
        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 auto-rows-[240px] gap-5">
          {AMENITIES.map((a, i) => (
            <Reveal key={a.key} delay={i * 0.08} className={a.span}>
              <article
                data-testid={`amenity-${a.key}`}
                className="group relative h-full w-full overflow-hidden gold-border"
              >
                <img
                  src={a.image}
                  alt={a.title}
                  className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/25 to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <h3 className="font-serif-lux text-2xl text-[#f5f5f0]">
                    {a.title}
                  </h3>
                  <p className="mt-2 text-sm text-[#c9c5ba]/80 opacity-0 translate-y-2 transition-all duration-500 group-hover:opacity-100 group-hover:translate-y-0">
                    {a.desc}
                  </p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        {/* Tag row */}
        <Reveal delay={0.2}>
          <div className="mt-10 flex flex-wrap gap-3">
            {AMENITY_TAGS.map((t) => (
              <span
                key={t}
                className="rounded-full border border-[#d4af37]/25 px-5 py-2.5 text-xs tracking-[0.12em] uppercase text-[#c9c5ba] hover:border-[#d4af37]/70 hover:text-[#d4af37] transition-colors duration-300"
              >
                {t}
              </span>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
